import { useState } from '#app'
import { useSlideIn } from '~/modules/ui/runtime'

export function useBasketFlyout() {
  const activeBasketState = useState('activeBasketState', () => false)

  const { toggle, isOpen } = useSlideIn('mobileBasketInfo')

  const closeModalCard = () => {
    activeBasketState.value = false
    if (isOpen.value) {
      toggle()
    }
  }

  return {
    closeModalCard,
    activeBasketState,
  }
}
